

import Service from './Service';

class Tracking extends Service {

    saveTracking(trackingInfo) {
        return this.axiosInstance.post(`/tracking`, trackingInfo);
    }

}

export default Tracking;